import { render, staticRenderFns } from "./GlobalPartnerCreateChoose.vue?vue&type=template&id=16194fc9&scoped=true"
import script from "./GlobalPartnerCreateChoose.vue?vue&type=script&lang=js"
export * from "./GlobalPartnerCreateChoose.vue?vue&type=script&lang=js"
import style0 from "./GlobalPartnerCreateChoose.vue?vue&type=style&index=0&id=16194fc9&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16194fc9",
  null
  
)

export default component.exports